import { useState, useCallback } from "react";

/**
 * Hook for tracking dirty (unsaved) state in forms.
 *
 * @param {boolean} [initialDirty=false] - Initial dirty state.
 * @returns {{
 *   isDirty: boolean,
 *   markDirty: () => void,
 *   clearDirty: () => void
 * }}
 */
export function useDirtyFormState(initialDirty = false) {
  const [isDirty, setIsDirty] = useState(initialDirty);

  const markDirty = useCallback(() => {
    setIsDirty(true);
  }, []);

  const clearDirty = useCallback(() => {
    setIsDirty(false);
  }, []);

  return {
    isDirty,
    markDirty,
    clearDirty
  };
}
